var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"680px","content-class":"fixed-height-md"},model:{value:(_vm.isDialogOpen),callback:function ($$v) {_vm.isDialogOpen=$$v},expression:"isDialogOpen"}},[_c('SetPhoneLine',{on:{"close":function($event){_vm.isDialogOpen = false},"completed":function($event){return _vm.$emit('finish')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }